import React from 'react';
import { RichText } from 'prismic-reactjs';

export default function Text({ slice }) {
  return <div className="blog-details-body-about">{RichText.render(slice.primary.blog_text.raw)}</div>;
}
